import { render, staticRenderFns } from "./ItemStrip.vue?vue&type=template&id=28c73a58&lang=pug&"
import script from "./ItemStrip.vue?vue&type=script&lang=js&"
export * from "./ItemStrip.vue?vue&type=script&lang=js&"
import style0 from "./ItemStrip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ItemStrip.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VMenu,
  VTextField,
  VTooltip,
})
